import { ServerFetch } from '../main-model'

export default class CreditNoteSupplierListModel extends ServerFetch {
    getCreditNoteSupplierListBy = (data) => this.authFetch({
        url: 'credit-note-supplier-list/getCreditNoteSupplierListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    generateCreditNoteSupplierListBy = (data) => this.authFetch({
        url: 'credit-note-supplier-list/generateCreditNoteSupplierListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}